import { render, staticRenderFns } from "./CardRespuesta.vue?vue&type=template&id=ce896f10&"
import script from "./CardRespuesta.vue?vue&type=script&lang=js&"
export * from "./CardRespuesta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports